import React, { useState, useRef, useEffect } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import {
  getL2SheetProperty,
  setLevel2Properties,
} from "../../../WorkbookSlice";
import {
  getColourScemeOptions,
  getDefaultColourScheme,
} from "../../../../../Colors/ColorPalettes";
import FourColorBoxComp from "./FourColorBoxComp";
import CustomColorControlerComp from "./CustomColorControlerComp";
import ExpandableWithToggle from "../../../../../components/BasicComponents/ExpandableWithToggle";
function CustomSelect({ options, onSelect }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  // console.log(selectedOption);

  const dropdownRef = useRef(null);

  // console.log(options);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    onSelect(option);
    setIsOpen(false);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative w-full h-full" ref={dropdownRef}>
      <div
        className="p-1 font-light border rounded border-gray-200 cursor-pointer bg-white flex items-center justify-between"
        onClick={toggleDropdown}
      >
        {selectedOption ? selectedOption.label : "select a option"}
        {isOpen ? (
          <MdKeyboardArrowUp className="text-2xl relative left-1" />
        ) : (
          <MdKeyboardArrowDown className="text-2xl relative left-1" />
        )}
      </div>
      {isOpen && (
        <div className="overflow-y-auto absolute z-10 w-full mt-1 bg-white border border-gray-300 shadow h-[8rem] rounded-lg flex items-start justify-between flex-col mb-4">
          {options.map((option) => (
            <div
              key={option.value}
              className=" py-2 pl-2 cursor-pointer hover:bg-gray-200 w-full rounded flex gap-2 items-center justify-between px-2"
              onClick={() => handleOptionClick(option)}
            >
              <button className="truncate font-light ">{option.label}</button>{" "}
              <FourColorBoxComp colors={option.colors} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function ColorControlerComp({
  ControllerProps,
  currentSheet,
  parentKey,
  dispatchItemToredux,
  VizchartType,
}) {
  const colourSchemeType = "RANDOM";
  const colorSchemes = getColourScemeOptions(colourSchemeType);
  const colors = colorSchemes.map((scheme) => ({
    value: scheme.id,
    label: scheme.label,
    colors: scheme.colors.slice(0, 4),
  }));
  // console.log(colorSchemes);
  const customColors = colorSchemes.map((scheme) => ({
    value: scheme.id,
    label: scheme.label,
    colors: scheme.colors,
  }));
  // console.log(customColors);

  const { title, reduxKey, itemInArray, defaultValue } = ControllerProps;
  const { Sheetid } = currentSheet;
  const dispatch = useDispatch();
  const customizdata = useSelector((state) => {
    getL2SheetProperty(state, Sheetid, "customization", "colorScheme");
  });

  // Define default colors
  const defaultColors = getDefaultColourScheme(colourSchemeType).colors;
  
  const handleColorChange = (option) => {
    const { value } = option;
    // console.log(value);

    // Find the selected color object from the colorSchemes array
    const selectedColourObject = colorSchemes.find((obj) => obj.id === value);
    // console.log(option);
    // Use selected colors if available, otherwise default to defaultColors
    const newColors = selectedColourObject
      ? selectedColourObject.colors
      : defaultColors;
    // console.log(newColors);
    // Create the color array
    const colourArray = [
      {
        type: "Random",
        colors: newColors,
      },
    ];

    // console.log(colourArray);

    // Dispatch action to update Redux state
    dispatch(
      setLevel2Properties({
        reduxKey,
        Sheetid,
        parentKey,
        value,
        itemInArray,
      })
    );
    dispatch(
      setLevel2Properties({
        reduxKey: "colorSchemeType",
        Sheetid,
        parentKey,
        value: "RANDOM",
        itemInArray,
      })
    );
    dispatch(
      setLevel2Properties({
        reduxKey: "colorMapping",
        Sheetid,
        parentKey,
        value: {},
        itemInArray,
      })
    );
  };
  const [customColorModal, setCustomColorModal] = useState(false);
  // console.log(customColorModal);
  return (
    <main className="w-full flex gap-2 justify-center items-center h-[100%]">
      <ExpandableWithToggle
        ControllerProps={ControllerProps}
        currentSheet={currentSheet}
        dispatchItemToredux={dispatchItemToredux}
        defaultValue={defaultValue}
        componentType="CONTAINER_WITH_CUSTOM_BUTTON"
        customButtonState={setCustomColorModal}
      >
        <CustomSelect options={colors} onSelect={handleColorChange} />
      </ExpandableWithToggle>
      {customColorModal ? (
        <CustomColorControlerComp
          customColorModal={customColorModal}
          setCustomColorModal={setCustomColorModal}
          options={customColors}
          Sheetid={Sheetid}
          ControllerProps={ControllerProps}
          dispatchItemToredux={dispatchItemToredux}
          handleColorChange={handleColorChange}
          VizchartType={VizchartType}
        />
      ) : null}
    </main>
  );
}
